export default {
    american: [
        "am general",
        "buick",
        "cadillac",
        "chevrolet",
        "chrysler",
        "dodge",
        "eagle",
        "fisker",
        "ford",
        "freightliner",
        "geo",
        "gmc",
        "hummer",
        "jeep",
        "lincoln",
        "mercury",
        "oldsmobile",
        "panoz",
        "plymouth",
        "pontiac",
        "ram",
        "saturn",
        "tesla"
    ],
    asian: [
        "acura",
        "daewoo",
        "genesis",
        "honda",
        "hyundai",
        "infiniti",
        "isuzu",
        "kia",
        "lexus",
        "mazda",
        "mitsubishi",
        "nissan",
        "scion",
        "subaru",
        "suzuki",
        "toyota"
    ],
    european: [
        "mini",
        "alfa romeo",
        "aston martin",
        "audi",
        "bentley",
        "bmw",
        "ferrari",
        "fiat",
        "jaguar",
        "lamborghini",
        "land rover",
        "lotus",
        "maserati",
        "maybach",
        "mclaren",
        "mercedes-benz",
        "porsche",
        "rolls-royce",
        "saab",
        "smart",
        "volkswagen",
        "volvo"
    ],
    luxury: [
        "acura",
        "alfa romeo",
        "aston martin",
        "audi",
        "bentley",
        "bmw",
        "buick",
        "cadillac",
        "ferrari",
        "genesis",
        "infiniti",
        "jaguar",
        "lamborghini",
        "lexus",
        "lincoln",
        "maserati",
        "maybach",
        "mclaren",
        "mercedes-benz",
        "mini",
        "porsche",
        "rolls-royce",
        "tesla",
        "volvo"
    ]
};
